import i18n from "../../../i18n";
import { Meter } from "../Meter";
import type { EntitySummary } from "../../../api/types";

/** Shared by HealthTable (B07) and CompaniesList (B08); null/zero-total renders an em dash. */
export function Coverage({ mappingCoverage }: { mappingCoverage: EntitySummary["mappingCoverage"] }) {
  if (!mappingCoverage || mappingCoverage.total === 0) return <span className="coverage-none">—</span>;
  const { resolved, total } = mappingCoverage;
  return (
    <div className="coverage">
      <Meter pct={(resolved / total) * 100} />
      <span className="num">{i18n.t("format.ofTotal", { defaultValue: "{{n}} of {{total}}", n: resolved, total })}</span>
    </div>
  );
}
